export default "__VITE_ASSET__BY_REjIq__"